import { ANONYMOUS_USER, FieldValueSchema, normalizeUserContext, personaFromIdentityRow } from '@almadar/core';
import { identityEntitiesOf } from '@almadar/core/mock';

// src/viewer.ts
function identitySourceOf(schema) {
  const entity = identityEntitiesOf(schema.orbitals ?? [])[0];
  if (!entity) return { kind: "none" };
  if (entity.persistence === "runtime") {
    return { kind: "claims", fields: entity.fields.flatMap((f) => f.name === void 0 ? [] : [f.name]) };
  }
  return { kind: "directory", entity: entity.name };
}
function tokenUser(verified) {
  const user = { id: verified.uid };
  if (verified.email !== void 0) user.email = verified.email;
  if (verified.name !== void 0) user.name = verified.name;
  return user;
}
async function resolveViewer(verified, source, lookup) {
  if (verified === null) return ANONYMOUS_USER;
  if (source.kind === "none") {
    const claims = Object.fromEntries(
      Object.entries(verified.claims).map(([k, v]) => [k, FieldValueSchema.parse(v)])
    );
    const user = normalizeUserContext({ ...claims, uid: verified.uid, email: verified.email, name: verified.name });
    if (!user) throw new Error("@almadar/auth: a verified token carries no subject");
    return user;
  }
  if (source.kind === "claims") {
    const user = tokenUser(verified);
    for (const field of source.fields) {
      if (field === "id" || field === "email" || field === "name") continue;
      const value = verified.claims[field];
      if (value !== void 0) user[field] = FieldValueSchema.parse(value);
    }
    return user;
  }
  if (!lookup) {
    throw new Error(`@almadar/auth: [identity] entity ${source.entity} is persistent but no lookup was given`);
  }
  const row = await lookup.getById(source.entity, verified.uid);
  if (!row) return tokenUser(verified);
  const persona = personaFromIdentityRow({ ...row, id: verified.uid });
  if (!persona) throw new Error("@almadar/auth: a verified token carries no subject");
  return persona;
}

export { identitySourceOf, resolveViewer };
//# sourceMappingURL=index.js.map
//# sourceMappingURL=index.js.map